/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_APPLICATION_COUNT = gql`
  query Query(
    $totalApp: GetAppCountInput
    $draftApp: GetAppCountInput
    $pendingPaymentApp: GetAppCountInput
    $rejectedApp: GetAppCountInput
    $wpissued: GetAppCountInput
    $submittedApp: GetAppCountInput
  ) {
    draftApp: getApplicationCount(input: $draftApp)
    pendingPaymentApp: getApplicationCount(input: $pendingPaymentApp)
    rejectedApp: getApplicationCount(input: $rejectedApp)
    totalApp: getApplicationCount(input: $totalApp)
    wpissued: getApplicationCount(input: $wpissued)
    submittedApp: getApplicationCount(input: $submittedApp)
  }
`;
